import { create } from 'zustand';

const useAlertStore = create((set) => ({
  alert: null,
  showAlert: (message, title = 'Terserah', type = 'info') => {
    set({ alert: { message, title, type } });
  },
  hideAlert: () => set({ alert: null }),
}));

export default useAlertStore;
